import axios from 'axios';
import store from '../store/store.js';
import router from '@/router';
// 创建 Axios 实例
const instance = axios.create({
    baseURL: 'https://api.xibaba888.com', // 你的 API 基础 URL
    // baseURL: 'http://localhost:8081/index.php',
    timeout: 10000, // 请求超时时间
    headers: {
      'Content-Type': 'application/json',
      // 其他通用请求头
    },
});
  // 请求拦截器
instance.interceptors.request.use(
    config => {
      // 在发送请求之前做些什么
      // 例如，添加认证 token
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers['Token'] = token;
      }
    //   config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
      return config;
    },
    error => {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  instance.interceptors.response.use(
    response => {
      // 对响应数据做点什么
      return response;
    },
    error => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        store.commit('LOGOUT');
        store.commit('OPEN_LOGIN_MODAL', 'login')
        if (router.currentRoute.path !== '/') {
          router.push('/')
        }
      }
      return Promise.reject(error);
    }
  );

  export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js